import type { CustomJsonComponentConfig } from '@apps/websiteCustomJsonComponents/config';
import { FormDisplayAdd, FormDisplayGrabber } from './FormDisplaySidebar';
import { FormDisplayEdit } from './components/FormDisplayEdit';
import { FormDisplayGuest } from './components/FormDisplayGuest';

export const FormDisplayConfig: CustomJsonComponentConfig = {
  schemaUrl: 'https://withjoy.com/assets/public/schemas/FormCustomComponentV1_0_0.json',
  componentType: 'FormDisplay',
  adminSidebarComponent: {
    addComponentView: FormDisplayAdd,
    dragComponentView: FormDisplayGrabber,
    editComponentView: FormDisplayEdit,
    createComponentView: FormDisplayEdit,
  },
  guestSiteComponent: FormDisplayGuest,
};
